/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapDispatchToProps = exports.mapStateToProps = exports.ColorPicker = void 0;

var react_1 = __importDefault(require("react"));

var redux_1 = require("redux");

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'ColorPicker';
exports.name = name;

var ColorPicker = function ColorPicker(_ref) {
  var Frame = _ref.Frame,
      ColorSquare = _ref.ColorSquare,
      styles = _ref.styles,
      AnalyticsApi = _ref.AnalyticsApi;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
      _this.renderProperties = _this.renderProperties.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "handleClick",
      value: function handleClick(property, isSelected) {
        var select = this.props.select;

        if (isSelected) {
          return;
        }

        var attributeId = property.attributeId,
            id = property.id;

        var selection = _defineProperty({}, attributeId, id);

        AnalyticsApi.selectedProperty(selection);
        select(attributeId, id);
      }
    }, {
      key: "renderProperties",
      value: function renderProperties(props) {
        var _this2 = this;

        var env = props.env,
            model = props.model,
            _props$properties = props.properties,
            properties = _props$properties === void 0 ? [] : _props$properties,
            selectedId = props.selectedId;
        return properties.map(function (property) {
          var _a, _b;

          var isSelected = property.id === selectedId;
          return react_1.default.createElement(ColorSquare, {
            env: env,
            hex: (_a = property.display) === null || _a === void 0 ? void 0 : _a.hex,
            image: (_b = property.display) === null || _b === void 0 ? void 0 : _b.image,
            model: model,
            isSelected: isSelected,
            onClick: function onClick() {
              return _this2.handleClick(property, isSelected);
            },
            tooltip: property.name
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            attribute = _this$props.attribute,
            before = _this$props.before,
            classes = _this$props.classes;
        return react_1.default.createElement(Frame, {
          className: ['Color-Picker__container', classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container,
          key: attribute === null || attribute === void 0 ? void 0 : attribute.id
        }, before, this.renderProperties(this.props), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.ColorPicker = ColorPicker;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var attribute = ownProps.attribute;
  var api = state.api,
      app = state.app;
  var configuration = api.configuration;
  var env = app.env;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  var properties = attribute.properties.map(function (propertyId) {
    return db.getProperty(propertyId);
  });
  var selectedId = configuration[attribute.id] || '';
  var name = attribute.name;
  return {
    env: env,
    model: model,
    properties: properties,
    name: name,
    selectedId: selectedId
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    actions: {
      configuration: Object.assign({}, redux_1.bindActionCreators({
        select: brightsmith_redux_1.Actions.Configuration.set
      }, dispatch))
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var style = function style(theme) {
  var _a;

  return {
    container: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      margin: 45,
      marginTop: 0,
      marginBottom: 0
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.ColorPicker) === null || _a === void 0 ? void 0 : _a.container)
  };
};

exports.style = style;